import { TrackingEvents, useTracking } from "@clockwise/web-commons/src/util/analytics.util";
import React from "react";
import { loginUser } from "../../mutations";
import { LoginBtn } from "../login-btn";
import { HomeUninstallCard } from "./HomeUninstallCard";

export const DeactivationLogin = () => {
  const track = useTracking();

  return (
    <HomeUninstallCard
      title="Sign in to deactivate your account"
      description="If you want to completely remove Clockwise from your calendar, please sign in to deactivate your Clockwise account."
    >
      <div className="cw-mb-8 cw-w-fit cw-font-normal cw-body-base">
        <LoginBtn
          loginUserMutation={loginUser}
          label="Sign in to deactivate"
          labelStyle={{
            paddingLeft: 15,
            paddingRight: 20,
            textTransform: "none",
          }}
          preventLoginRedirect
          onStart={() => track(TrackingEvents.AUTH.BEGIN_LOGIN)}
          onSuccess={() => track(TrackingEvents.UNINSTALL.LOGIN)}
          onFailure={() => track(TrackingEvents.AUTH.LOGIN_FAILED)}
        />
      </div>
    </HomeUninstallCard>
  );
};
